import * as React from "react"
import { Fragment } from "react"
import { Disclosure, Transition } from "@headlessui/react"
import {
  PhoneIcon,
  Bars3Icon as MenuIcon,
  XMarkIcon as XIcon,
} from "@heroicons/react/24/outline"

import Navlink from "./navLink"
import CallItem from "../images/CallItem"
import { PageContext } from "../context/pageProvider"
import { getImageUrl } from "../utils/getImageUrl"
import LazyLoad from "react-lazy-load"

export const linkToContact = "/kontakt-offert"

export function Navigation() {
  const { meta } = React.useContext(PageContext)
  const {
    navigation,
    logo,
    nimbata,
    callInHeader,
    callInHeaderDesktop,
    logo_link,
    contact_us_link,
  } = meta.settings
  const [headerStyle, setHeaderStyle] = React.useState(false)

  React.useEffect(() => {
    document.addEventListener("scroll", () => {
      if (window.pageYOffset > 40) {
        setHeaderStyle(true)
      } else {
        setHeaderStyle(false)
      }
    })
  }, [])

  const contactInfo = navigation?.find(item => item.pageType === "contact")

  return (
    <div
      className={`w-full fixed bg-white opacity-95 z-40 sm:pb-2 lg:pb-2 ease-in duration-300 ${
        headerStyle ? "p-0 shadow-sm" : ""
      }`}
    >
      <Disclosure>
        {callInHeader && (
          <div className="flex gap-1 text-white  primaryBg justify-center md:hidden m-auto items-center w-full px-2 py-3">
            {/* <span className="text-sm leading-none"> Fri konsultation</span> */}
            <a
              id="button11"
              className="border-white px-0.5  grow-0 leading-none flex gap-1 pt-0.5 text-center border text-white "
              href={`tel:${nimbata}`}
            >
              <CallItem />
              {nimbata}
            </a>
          </div>
        )}
        <div
          className={`relative lg:pt-2 lg:pr-4 pl-4 elva ease-in duration-300 ${
            !headerStyle && logo?.logoHeight > 42 && logo?.logoHeight < 101
              ? "!my-2"
              : "!my-0"
          }`}
        >
          <nav
            className={`relative ease-in duration-300 lg:flex items-center flex-grow justify-between ${
              logo?.logoHeight > 42 && logo?.logoHeight < 101
                ? headerStyle
                  ? `h-[${logo.logoHeight}px] lg:h-[${logo.logoHeight - 8}px]`
                  : `h-[${logo.logoHeight + 16}px] lg:h-[${
                      logo.logoHeight + 8
                    }px]`
                : headerStyle
                ? "h-12 lg:h-10"
                : "h-16 lg:h-14"
            } `}
            aria-label="Global"
          >
            <div className="flex items-center flex-grow flex-shrink-0 lg:flex-grow-0 h-full">
              <div className="flex items-center justify-between w-full lg:w-auto py-2 lg:py-0 h-full">
                <div className="flex items-center h-full">
                  <Navlink
                    href={
                      logo_link ||
                      (process.env.PREVIEW_ENABLED
                        ? `?parentId=${meta.settings.sanityParent._ref}`
                        : "")
                    }
                    className="flex items-center h-full"
                  >
                    <LazyLoad
                      className={`${
                        logo?.logoHeight > 42 && logo?.logoHeight < 101
                          ? `h-[${logo?.logoHeight}px]`
                          : "h-[42px]"
                      } flex`}
                    >
                      <img
                        style={{
                          width: logo?.logoSize + "px",
                          height:
                            logo?.logoHeight && logo?.logoHeight < 101
                              ? logo?.logoHeight + "px"
                              : "100%",
                        }}
                        className={
                          logo?.logoHeight && logo?.logoHeight < 101
                            ? `max-h-[${logo.logoHeight}] self-center`
                            : "h-full "
                        }
                        src={getImageUrl(logo?.asset?._ref)}
                        alt={logo?.alttext || "logo"}
                      />
                    </LazyLoad>
                  </Navlink>
                  {callInHeaderDesktop && (
                    <div>
                      <div
                        className={`ml-2.5 ease-in duration-300 hidden md:flex ${
                          headerStyle
                            ? "text-sm px-2 leading-6"
                            : "text-xl px-2.5"
                        }`}
                      >
                        <PhoneIcon
                          fill="black"
                          className={`ease-in duration-300 opacity-75 ${
                            headerStyle ? "h-6 w-6" : "h-7 w-7"
                          }`}
                        />
                        <a
                          id="button8"
                          className="text-black text-center pl-[13px]"
                          href={`tel:${nimbata}`}
                        >
                          {nimbata}
                        </a>
                      </div>
                    </div>
                  )}
                </div>
                <div className="flex">
                  <div className="mr-1 flex items-center lg:hidden">
                    <Disclosure.Button className="bg-white rounded-md p-2 mr-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-inset">
                      <span className="sr-only">Öppna meny</span>
                      <MenuIcon
                        className={`ease-in duration-300 ${
                          headerStyle ? "h-6 w-6" : "h-7 w-7"
                        }`}
                        aria-hidden="true"
                      />
                    </Disclosure.Button>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex gap-4 items-center">
              <div className="hidden lg:block md:ml-10">
                {navigation &&
                  navigation.map(
                    item =>
                      item.title !== "Hem" &&
                      item.pageType !== "contact" && (
                        <Navlink
                          href={
                            process.env.PREVIEW_ENABLED
                              ? `?parentId=${item.sanityParent._ref}&pageId=${item._id}`
                              : `${item.slug.current}`
                          }
                          key={item.slug.current}
                          active={item.isActive}
                          className="font-medium text-gray-500 xl:text-base py-2 border-b m-1.5 border-neutral-300 hover:text-gray-700 hover:border-black"
                          activeClassName="border-black text-black"
                        >
                          {item.title}
                        </Navlink>
                      )
                  )}
              </div>
              <div className="rounded-md hidden lg:block shadow mx-auto">
                {contactInfo && (
                  <Navlink
                    href={
                      contact_us_link ||
                      (process.env.PREVIEW_ENABLED
                        ? `?parentId=${contactInfo.sanityParent._ref}&pageId=${contactInfo._id}`
                        : `${contactInfo.slug.current}`)
                    }
                    key={contactInfo.slug.current}
                    active={contactInfo.isActive}
                    className="kontakt-nav-btn btn flex items-center justify-center text-base font-medium rounded-md text-white hover:opacity-100 "
                  >
                    <button id="button4" className="w-full h-full px-3 py-3 ">
                      {contactInfo.title}
                    </button>
                  </Navlink>
                )}
              </div>
            </div>
          </nav>
        </div>

        <Transition
          as={Fragment}
          enter="duration-150 ease-out"
          enterFrom="opacity-0 scale-95"
          enterTo="opacity-100 scale-100"
          leave="duration-100 ease-in"
          leaveFrom="opacity-100 scale-100"
          leaveTo="opacity-0 scale-95"
        >
          <Disclosure.Panel className="absolute z-20 top-0 inset-x-0 p-2 transition transform origin-top-right lg:hidden">
            <div className="rounded-lg shadow-md bg-white ring-1 ring-black ring-opacity-5 overflow-hidden">
              <div className="pr-5 pl-2 pt-4 flex items-center justify-end">
                <div className="-mr-2">
                  <Disclosure.Button className="bg-white rounded-md inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary-500">
                    <div className="-z-10 w-screen h-screen absolute left-0"></div>
                    <span className="sr-only">Stäng navigation</span>
                    <XIcon className="h-6 w-6" aria-hidden="true" />
                  </Disclosure.Button>
                </div>
              </div>
              <div className="px-2 pt-2 pb-3 space-y-1">
                {navigation?.map(
                  item =>
                    item.title !== "Hem" &&
                    item.pageType !== "contact" && (
                      <Navlink
                        key={item.title}
                        href={
                          process.env.PREVIEW_ENABLED
                            ? `?parentId=${item.sanityParent._ref}&pageId=${item._id}`
                            : `${item.slug.current}`
                        }
                        activeClassName="text-primary-600"
                        className="flex sm:block px-3 py-2 text-center rounded-md text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50"
                      >
                        {item.title}
                      </Navlink>
                    )
                )}
                <div className="rounded-md block lg:hidden sm:shadow mx-auto">
                  {contactInfo && (
                    <Navlink
                      key={contactInfo.title}
                      href={
                        process.env.PREVIEW_ENABLED
                          ? `?parentId=${contactInfo.sanityParent._ref}&pageId=${contactInfo._id}`
                          : `${contactInfo.slug.current}`
                      }
                      className="w-fit sm:w-full kontakt-nav-btn flex items-center justify-center text-base font-medium rounded-md text-black sm:text-white hover:opacity-100"
                    >
                      <button id="button5" className="w-full h-full px-3 py-3">
                        {contactInfo.title}
                      </button>
                    </Navlink>
                  )}
                </div>
                <div className="flex text-sm px-2 leading-6">
                  <div className="flex sm:mx-auto">
                    <PhoneIcon
                      stroke="black"
                      fill="black"
                      className="h-6 w-6"
                    />
                    <a
                      id="button9"
                      className="text-black flex sm:text-center pl-2"
                      href={`tel:${nimbata}`}
                    >
                      {nimbata}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </Disclosure.Panel>
        </Transition>
      </Disclosure>
    </div>
  )
}

export default Navigation
